module.exports = __webpack_public_path__ + "components/country-flag/static/ec-216ea8f8552ae8de4934815c335833b2.svg";